import { Ordine, StatoOrdine, OrdineNuovo, ConsumabileMatricola } from './models';
import { DestinatarioMatricola, TipoIntervento } from '../core-assistenza';
import { query, command } from '../api';
import { ApplicationState } from '..';
import { PageResult } from '../core';

export const getDestinatariMatricole = (
    state: ApplicationState,
    tipologia: TipoIntervento, 
    search: string, 
    refreshCache: boolean
): Promise<DestinatarioMatricola[]> => {
    search = search || '';
    const url: string = '/api/matricole/raggruppate';
    const cacheType: RequestCache = refreshCache ? "reload" : "default";
    const parametri: Object = { 
        search, 
        tipologia 
    };

    return query<DestinatarioMatricola[]>(url, state, parametri, cacheType);
}

export const getConsumabiliMatricola = (
    state: ApplicationState,
    idSpecifica: string,
    refreshCache: boolean
): Promise<ConsumabileMatricola[]> => {
        const url: string = '/api/matricole/consumabili';
        const cacheType: RequestCache = refreshCache ? "reload" : "default";
        const parametri: Object = { 
            idSpecifica
        };

    return query<ConsumabileMatricola[]>(url, state, parametri, cacheType);
}

export const getOrdini = (
    state: ApplicationState,
    search: string,
    page: number,
    refreshCache: boolean,
    stato?: StatoOrdine
): Promise<PageResult<Ordine>> => {
    search = search || '';
    const url: string = '/api/ordini';;
    const cacheType: RequestCache = refreshCache ? "reload" : "default";
    const parametri: Object = { 
        search, 
        stato,
        page
    };

    return query<PageResult<Ordine>>(url, state, parametri, cacheType);
}

export const saveOrdine = (
    state: ApplicationState,
    ordine: OrdineNuovo
): Promise<string> => {
    const url = '/api/ordini';
    return command(url, state, JSON.stringify(ordine));
}